<template lang="pug">
  div.auth.login
    div.modal.login
      div.modal.login-inner
        form.aside(@submit.prevent="onSubmit")
          div.input
            input(type="text" name="username" v-model="username" :placeholder="$translate('Логин')" required minlength=2)
          div.input
            input(type="password" name="password" v-model="password" :placeholder="$translate('Пароль')" required minlength=2)
          div
            button(type="submit" id="submit" v-bind:disabled="loading") {{loading ? $translate('Загрузка...') : $translate('Вход')}}
          transition(name="fade")
            div(v-if="error")
              span {{error}}
          div.actions
            router-link(
              :to="{path: 'request-reset-password'}"
            ) {{$translate('Забыли пароль?')}}
        form.center
          h1 {{$translate('Электронная модель территориальной схемы')}}
          div.links
            router-link(
              :to="{name: 'geo.objects'}"
            ) {{ $translate('Публичная карта объектов') }}
          div.links
            router-link(
              :to="{name: 'geo.treads'}"
            ) {{ $translate('Публичная схема потоков') }}
          div.links
            router-link(
              :to="{name: 'publicFiles.files'}"
              target="_blank"
            ) {{ $translate('Материалы территориальной схемы') }}

</template>

<script>
import loginFormMixin from '../mixins/login-form'

export default {
  name: 'login',
  mixins: [loginFormMixin],
}
</script>
